import React from "react";
import PropTypes from "prop-types";
import { CollapseBlock } from "ComponentsUI/CollapseBlock";
import HtmlEditableBlock from "ComponentsUI/HtmlEditableBlock";


const AboutMe = props => {
    let { data, title, windowSizes, baseOffset, styleNone } = props;

    return (
        <CollapseBlock
            underline={true}
            windowSize={windowSizes}
            header={title || null}
            baseOffset={baseOffset}
        >
            <HtmlEditableBlock text={data} styleNone={styleNone} />
        </CollapseBlock>
    );
};

AboutMe.propTypes = {
    data: PropTypes.string,
    title: PropTypes.string,
    windowSizes: PropTypes.object,
    baseOffset: PropTypes.bool,
    styleNone: PropTypes.bool,
};

export default AboutMe;
